// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/valid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/icons/error.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file {
    position: relative;
}
.file::before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: -25px;
    top: 0;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.file.valid::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.file.error::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.file label {
    margin: 0 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/Upload/UploadBatch.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,yDAAmD;AACvD;AACA;IACI,yDAAmD;AACvD;AACA;IACI,aAAa;AACjB","sourcesContent":[".file {\n    position: relative;\n}\n.file::before {\n    content: '';\n    display: block;\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    left: -25px;\n    top: 0;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n.file.valid::before {\n    background-image: url(../../assets/icons/valid.svg);\n}\n.file.error::before {\n    background-image: url(../../assets/icons/error.svg);\n}\n.file label {\n    margin: 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
